import React from "react";
import "./ExchangePolicy.css";
import HomeHeader from "../../components/header/HomeHeader";
import CommonFooter from "../../components/footer/CommonFooter";
import Breadcrumb from "../../components/breadcrumb";

const ExchangePolicy = () => {
  return (
    <div className="exchange-policy">
      <HomeHeader />
      <Breadcrumb
        items={[
          { 
            label: "Home",
            path: "/",
          },
          {
            label: "Refund Policy",
            isActive: true,
          },
        ]}
      />

      <main className="exchange-policy__main">
        <div className="exchange-policy__container">
          <div className="exchange-policy__content">
            <h1 className="exchange-policy__title">Refund policy</h1>
            <h1 className="exchange-policy__subtitle">Cancellation & Exchange Policy</h1>
            
            <p className="exchange-policy__intro">
              Codeinfoway follows a friendly policy to ensure your purchases are free of stress. We offer a "100% Buyer Protection Program" for our valued customers. We are always with you, before and after your purchase. As an additional measure, please read through the following terms & conditions prior to making a purchase.
            </p>

            <div className="exchange-policy__section">
              <p className="exchange-policy__highlight">
                IN ALL CASES OF EXCHANGE, YOU CAN DROP US A WhatsApp +91 9016501095 and YOU WILL GET A REVERT WITHIN 48-72 WORKING HOURS.
              </p>
            </div>

            <div className="exchange-policy__section">
              <h2 className="exchange-policy__section-title">DOMESTIC CUSTOMERS</h2>
              
              <div className="exchange-policy__subsection">
                <h3 className="exchange-policy__subsection-title">EXCHANGE BY DOMESTIC CUSTOMER</h3>
                
                <h4 className="exchange-policy__subheading">Size Exchange/Product Exchange:</h4>
                <p>
                  If the customer has any size issue with the product or wants a different product in place of the previous one then he/she needs to WhatsApp us at +91 9016501095 within 5 Days from the date of delivery of the parcel. and we no have any reverse pickup service so customer have to self courier to our address and shipping charges also on customer.
                </p>
                
                <p className="exchange-policy__note">
                  <strong>Please Note:</strong> Reverse pick-up not be available. In this case the customer is requested to send back with the customer name and mobile on it. Exchange are allowed on size issues only. Exchange will not be issued on product exchange. All purchases made on offers and discounts are non exchangeable.
                </p>
              </div>

              <div className="exchange-policy__subsection">
                <h4 className="exchange-policy__subheading">Return:</h4>
                <p>We don't take returns on items sold once.</p>
              </div>

              <div className="exchange-policy__subsection">
                <h4 className="exchange-policy__subheading">Damaged/Wrong Delivery:</h4>
                <p>
                  If it's a damaged/defective product, incorrect item sent, we will replace the product with the next fastest possible courier facility. However, when a product is shipped from our warehouse it goes under 3 layers of quality check and we record the process for your reference as well. Still, if there is an issue with the product we would resolve it for you.
                </p>
              </div>
            </div>

            <div className="exchange-policy__section">
              <h2 className="exchange-policy__section-title">When Exchange is not accepted?</h2>
              <ul className="exchange-policy__list">
                <li>Exchange not accepted due to color Difference. 10% Colour difference might be there due to screen resolution and lights.</li>
                <li>Exchanges are not accepted if Customer does not like the material or colour of the product order. As we use the best quality material in the market and all product details are mentioned in the Product description. We would suggest you please read all the details before placing the order.</li>
                <li>Exchanges are not accepted if the piece is specially customised of the customer.</li>
              </ul>
            </div>

            <div className="exchange-policy__section">
              <h2 className="exchange-policy__section-title">CANCELLATIONS BY INDIAN CUSTOMER</h2>
              <p>No, you can't cancel the parcel once the order has been placed</p>
            </div>

            <div className="exchange-policy__section">
              <h2 className="exchange-policy__section-title">INTERNATIONAL CUSTOMERS</h2>
              <p>
                If your product arrives damaged or you receive the wrong product, you should email us at codeinfoway.in@gmail.com along with a photo of the damaged product. The mail should be sent within 24 hours of delivery of damaged items in your shipment. In such cases, we offer a resolution.
              </p>
              <p>All Custom Duties levied on the products will be borne by the customer.</p>
              <p>For Exchanges by international customers, the above policy is applicable. Any other questions or clarifications, please contact us at contact@codeinfoway.com</p>
            </div>

            <div className="exchange-policy__section">
              <h2 className="exchange-policy__section-title">CANCELLATIONS BY INTERNATIONAL CUSTOMER</h2>
              <p>
                Unfortunately you can't cancel the order, once you placed. all you can do is to exchange or replace the product.. mail us at
              </p>
              <p>
                Cancellation policy is not available all you can do is exchange the size or style and mail us at contact@codeinfoway.com
              </p>
            </div>
          </div>
        </div>
      </main>

      <CommonFooter />
    </div>
  );
};

export default ExchangePolicy;

